import TravelRule from './TravelRule'

export default TravelRule
